/**
 * Application configuration
 * This centralizes all environment variables and configuration settings
 */

// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000',
  TIMEOUT: 30000, // 30 seconds
};

// Feature flags
export const FEATURES = {
  ENABLE_AUTH: true,
};

// Other app configuration
export const APP_CONFIG = {
  APP_NAME: 'Aralin Insights',
  APP_VERSION: '1.0.0',
};

const SCHOOL_DISPLAY_NAMES: Record<string, string> = {
  base: 'Aralin',
  poveda: 'Poveda',
  lsgh: 'LSGH',
  dlsz: 'DLSZ',
  usls: 'USLS',
};

const schoolKey = (process.env.NEXT_PUBLIC_SCHOOL || 'base').toLowerCase();

export const SCHOOL_NAME = SCHOOL_DISPLAY_NAMES[schoolKey] ?? 'Aralin';

// Theme configuration
export const THEME_CONFIG = {
  PRIMARY_COLOR: process.env.NEXT_PUBLIC_PRIMARY_COLOR || '#44AA88',
  BACKGROUND_COLOR: process.env.NEXT_PUBLIC_BACKGROUND_COLOR || '#F2F6F5',
  SIDEBAR_TEXT_COLOR: process.env.NEXT_PUBLIC_SIDEBAR_TEXT_COLOR || '#FFFFFF',
  GRADIENT_HERO: process.env.NEXT_PUBLIC_GRADIENT_HERO || 'linear-gradient(to bottom left, #A6CFF2, #B9E4D5)',
};